<div class="row mb-3" style="margin-top:65px">
  <div class="col-12">
    <a [routerLink]="'/hourglass/tools'">
      <i class="fas fa-fw fa-lock me-2"></i>Admin Tools<i class="fas fa-fw fa-chevron-right mx-2"></i>
    </a>
    <i class="fas fa-fw fa-object-group me-2"></i>Teams Manager
  </div>
</div>
<div class="plaid-link-container">
    <button
      id="plaid-link-button"
      class="plaid-link-button"
      (click)="openPlaidLink()"
    >
      Connect Bank Account
    </button>
  </div>